import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { XFlowNodeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
export var NsUpdateNodePort;
(function (NsUpdateNodePort) {
    /** Command: 用于注册named factory */
    NsUpdateNodePort.command = XFlowNodeCommands.UPDATE_NODE_PORT;
    /** hookName */
    NsUpdateNodePort.hookKey = 'updateNodePort';
})(NsUpdateNodePort || (NsUpdateNodePort = {}));
let UpdateNodePort = 
/** 创建节点命令 */
class UpdateNodePort {
    constructor() {
        this.getCell = (graph, node) => {
            if (typeof node === 'string') {
                return graph.getCellById(node);
            }
            return node;
        };
        this.getNodeConfig = (x6Node) => {
            const data = x6Node.getData();
            const position = x6Node.getPosition();
            const size = x6Node.getSize();
            return Object.assign(Object.assign(Object.assign({}, data), position), size);
        };
        this.updatePortsOfNodeConfig = (cell, ports, options) => {
            const nodeConfig = this.getNodeConfig(cell);
            if (this.isNodeAnchors(nodeConfig.ports)) {
                nodeConfig.ports = [...ports];
            }
            if (this.isPortMetaData(nodeConfig.ports)) {
                nodeConfig.ports.items = [...ports];
            }
            cell.setData(nodeConfig, options);
        };
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const graph = yield ctx.getX6Graph();
            const result = yield hooks.updateNodePort.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { node, updatePorts, options, commandService } = handlerArgs;
                const cell = this.getCell(graph, node);
                if (!cell || cell.isEdge()) {
                    console.error('node_is _not_exsit', node);
                    return { err: 'node_is _not_exsit' };
                }
                const currentPorts = cell.getPorts();
                const nextPorts = yield updatePorts([...currentPorts], cell, graph);
                if (nextPorts === false) {
                    return { err: 'service rejected' };
                }
                cell.setPropByPath('ports/items', nextPorts, Object.assign({ rewrite: true }, options));
                /** update nodeConfig */
                this.updatePortsOfNodeConfig(cell, nextPorts, options);
                /** add undo */
                ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                    commandService.executeCommand(XFlowNodeCommands.UPDATE_NODE_PORT.id, { node, updatePorts: () => __awaiter(this, void 0, void 0, function* () { return currentPorts; }) });
                })));
                return { ports: nextPorts };
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isNodeAnchors(ports) {
        return Array.isArray(ports);
    }
    isPortMetaData(ports) {
        return ports.items && Array.isArray(ports.items);
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], UpdateNodePort.prototype, "contextProvider", void 0);
UpdateNodePort = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsUpdateNodePort.command.id },
    })
    /** 创建节点命令 */
], UpdateNodePort);
export { UpdateNodePort };
//# sourceMappingURL=node-update-port.js.map